<template>
  <div>
    <div class="page-header">
      <h3>Arrays</h3>
    </div>
    <TaskExpander />
    <NewQuickTask />
    <h4 v-if="inboxTasks.length > 0" class="mt-4">Inbox</h4>
    <ul class="mt-2 list-group">
      <li v-for="task in inboxTasks" :key="task.id" class="list-group-item js-task-details-collapse-container" v-bind:class="{ 'bg-light': task.kind == 'comment' }">
        <QuickTask :task="task" />
      </li>
    </ul>
    <span v-for="projectArea in projectAreas">
      <span v-for="project in projectArea.projects">
        <h4 v-if="projectTasks(project.id).length" class="mt-4">{{projectArea.name}} {{project.name}}</h4>
        <ul class="mt-2 list-group">
          <li v-for="task in projectTasks(project.id)" :key="task.id" class="list-group-item js-task-details-collapse-container" v-bind:class="{ 'bg-light': task.kind == 'comment' }">
            <QuickTask :task="task"/>
          </li>
        </ul>
      </span>
    </span>
  </div>
</template>

<script>
import QuickTask from "components/QuickTask";
import NewQuickTask from "components/NewQuickTask";
import TaskExpander from "components/TaskExpander";

export default {
  components: {
    QuickTask,
    NewQuickTask,
    TaskExpander
  },
  computed: {
    inboxTasks: function(){
      return this.$store.state.tasks.filter(function (task){
        return (task.completed === false && task.journaled === false && task.project_id === null)
      })
    },
    projectAreas: {
      get() {
          return this.$store.state.project_areas
      }
    }
  },
  methods: {
    projectTasks: function(project_id){
      return this.$store.state.tasks.filter(function (task){
        return (task.project_id == project_id && (task.completed === false && task.journaled === false))
      })
      .sort(function(a, b) {
        return new Date(b.created_at) - new Date(a.created_at);
      });
    }
  }
};
</script>
